import DateRangeIcon from '@mui/icons-material/DateRange';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import {Link, useNavigate} from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Post, Section } from "../../common/types/post.types";
import {getImageUrl, getSectionInfoForPostBrief} from "../../utils/post-utils";
import {Tooltip} from "@mui/material";
import { useSelector } from "react-redux";
import {formatDate} from "../../utils/utils";

function PostBrief(props: Props) {
  const {post} = props;
  const navigate = useNavigate();
  const sections = useSelector((state: any) => state.sections.data);
  const [sectionInfo, setSectionInfo] = useState<Section>(null);

  function redirectToSeries() {
    navigate(`/detail/${post.sections.find(section => section.level === 1).path}/${post.id}`)
  }

  useEffect(() => {
    const subSections = Object.values(post.sections).map((item) => item.path);
    setSectionInfo(getSectionInfoForPostBrief(subSections, props.currentSectionTree, sections));
  }, [sections])

  return (
    <div className={"post-brief"}>
      <div className={"content"}>
        <div className={'post-info'} onClick={redirectToSeries}>
          <img src={getImageUrl(post?.thumbnail)} alt={"post"} />
          <div className={'content'}>
            {post.description}
          </div>
          <div className={'title'}>
            {post.name}
          </div>
        </div>
        <div className={"reading"}>
          <div className={'section-info'}>
            <img
              src={getImageUrl(sectionInfo?.icon)}
              alt={sectionInfo?.name}
            />
            <div>{sectionInfo?.name}</div>
          </div>
          <div className={'reading-info'}>
            <div className={'time'}>
              <Tooltip title="Last update">
                <span><DateRangeIcon className={'icon'}/>{formatDate(post.updated_at)}</span>
              </Tooltip>
              <Tooltip title="Reading time">
                <span><HistoryToggleOffIcon className={'icon'}/>{post.reading_time} minutes</span>
              </Tooltip>
            </div>
            <Link
              to={`/sections${props.currentSectionTree.length === 0 ? '' : '/'}${props.currentSectionTree.join('/')}/${sectionInfo?.path}`}
              className={'section'}>
              Go to {sectionInfo?.name} section
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostBrief;

class Props {
  post: Post;
  currentSectionTree: string[];
}
